// @ts-nocheck TODO: type issues need to be fixed in this file
export default (keys, hash) =>
  keys.reduce(
    (newHash, key) => (newHash && newHash[key] ? newHash[key] : null),
    hash,
  );
